import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import SupervisorDashboard from "@/pages/SupervisorDashboard";
import CounselorDashboard from "@/pages/CounselorDashboard";
import FollowRate from "@/pages/FollowRate";
import { Toaster } from "sonner";
import "@/App.css";

const Root = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "counselor" ? "/counselor" : "/supervisor"} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          dir="rtl"
          toastOptions={{
            style: { fontFamily: "'Tajawal', 'IBM Plex Sans Arabic', sans-serif", letterSpacing: "0" },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/f/:token" element={<FollowRate />} />
          <Route path="/supervisor/*" element={
            <ProtectedRoute role={["admin", "principal", "general_manager"]}><SupervisorDashboard /></ProtectedRoute>
          } />
          <Route path="/counselor/*" element={
            <ProtectedRoute role="counselor"><CounselorDashboard /></ProtectedRoute>
          } />
          <Route path="*" element={<Root />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
